import { render } from "./WithdrawalsPage.vue?vue&type=template&id=2758f0c4"
import script from "./WithdrawalsPage.vue?vue&type=script&lang=js"
export * from "./WithdrawalsPage.vue?vue&type=script&lang=js"
script.render = render

export default script